import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MoreHorizontalIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.4922 12C10.4922 11.1716 11.1638 10.5 11.9922 10.5H12.0012C12.8296 10.5 13.5012 11.1716 13.5012 12C13.5012 12.8284 12.8296 13.5 12.0012 13.5H11.9922C11.1638 13.5 10.4922 12.8284 10.4922 12Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.4919 12C16.4919 11.1716 17.1635 10.5 17.9919 10.5H18.0009C18.8293 10.5 19.5009 11.1716 19.5009 12C19.5009 12.8284 18.8293 13.5 18.0009 13.5H17.9919C17.1635 13.5 16.4919 12.8284 16.4919 12Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.49988 12C4.49988 11.1716 5.17145 10.5 5.99988 10.5H6.00886C6.83729 10.5 7.50886 11.1716 7.50886 12C7.50886 12.8284 6.83729 13.5 6.00886 13.5H5.99988C5.17145 13.5 4.49988 12.8284 4.49988 12Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MoreHorizontalIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MoreHorizontalIcon;
